export default __webpack_public_path__ + "static/media/paymentError.bc06b195.png";